import { DollarSign, FileBarChart, ShoppingCart } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import MetricCard from "./metricCard";
import ProductCard from "./productCard";

export default function DashboardContent() {
  const { client } = useAuth();

  return (
    <div className="p-4">
      {/* Titre personnalisé */}
      <h1 className="text-center fw-bold fs-3 mb-4">
        <span className="text-primary">Bienvenue</span> 
        {client ? ` ${client.nom || client.prenom || client.email}` : ""} SUR VOTRE TABLEAU DE
        BORD
      </h1>

      {/* Informations utilisateur connecté */}
      {client && (
        <div className="alert alert-info mb-4">
          <h5>👤 Informations de connexion :</h5>
          <p className="mb-1"><strong>Email :</strong> {client.email}</p>
          <p className="mb-1"><strong>Rôle :</strong> {client.role || 'Utilisateur'}</p>
          {client.nom && <p className="mb-1"><strong>Nom :</strong> {client.nom}</p>}
          {client.prenom && <p className="mb-1"><strong>Prénom :</strong> {client.prenom}</p>}
          {client.id && <p className="mb-0"><strong>ID :</strong> {client.id}</p>}
        </div>
      )}

      {/* Bouton d'intro */}
      <div className="mb-4">
        <button className="btn btn-sm rounded-pill bg-primary bg-opacity-10 text-primary fw-medium px-3">
          Aperçu des activités
        </button>
      </div>

      {/* Cartes de métriques */}
      <div className="row g-4 mb-4">
        <div className="col-12 col-md-4">
          <MetricCard
            icon={<FileBarChart size={28} color="#0d6efd" />}
            title="Nombre de ventes"
            value="100"
            color="primary"
          />
        </div>
        <div className="col-12 col-md-4">
          <MetricCard
            icon={<ShoppingCart size={28} color="#0d6efd" />}
            title="Nombre de commandes"
            value="100"
            color="primary"
          />
        </div>
        <div className="col-12 col-md-4">
          <MetricCard
            icon={<DollarSign size={28} color="#0d6efd" />}
            title="Chiffre d'affaire"
            value="1.000.000 FCFA"
            color="primary"
          />
        </div>
      </div>

      {/* Bouton section articles */}
      <div className="mb-4">
        <button className="btn btn-sm rounded-pill bg-primary bg-opacity-10 text-primary fw-medium px-3">
          Les articles les plus vendus
        </button>
      </div>

      {/* Cartes produits */}
      <div className="row g-4">
        {[1, 2, 3, 4, 5, 6].map((item) => (
          <div className="col-12 col-md-4" key={item}>
            <ProductCard />
          </div>
        ))}
      </div>
    </div>
  );
}
